import { LinkElement } from '@all-hands-hq/plex-graphql-schema';
import React from 'react';
import { Path, Range } from 'slate';
import { ReactEditor } from 'slate-react';

import { clearEditorMenu } from '../../../../actions/clearEditorMenu';
import { editLinkEditorMenu } from '../../../../actions/editLinkEditorMenu';
import { useGetLinkMetadataQuery } from '../../../../graphql/gen/types';
import { useDispatch } from '../../../../redux';
import { ReactEditorWithEntities } from '../internal/useSlate';
import { expandLink, unlinkLinkElement } from '../internal/withLinks';
import { LinkPreview } from './LinkPreview';

type Props = {
  editor: ReactEditorWithEntities;
  selection: Range;
  node: LinkElement;
  path: Path;
  isPrimaryLink: boolean;
  onChangePrimaryLink: (primaryLink: string) => void;
};

export const LinkPreviewContainer = ({
  editor,
  selection,
  node,
  path,
  isPrimaryLink,
  onChangePrimaryLink,
}: Props): React.ReactElement => {
  const { url } = node;
  const { data } = useGetLinkMetadataQuery({ variables: { url }, fetchPolicy: 'cache-first' });
  const dispatch = useDispatch();

  return (
    <LinkPreview
      url={url}
      preview={data == null ? { state: 'loading' } : { state: 'done', linkMetadata: data.linkMetadata }}
      isPrimaryLink={isPrimaryLink}
      onSetAsPrimaryLink={(): void => {
        onChangePrimaryLink(url);
      }}
      onEdit={(): void => {
        dispatch(editLinkEditorMenu(selection));
      }}
      expandDisabled={data == null || data.linkMetadata.details.__typename === 'InvalidLink'}
      onExpand={(): void => {
        if (!(data == null || data.linkMetadata.details.__typename === 'InvalidLink')) {
          expandLink(editor, node, path, data.linkMetadata.details);
          ReactEditor.focus(editor);
          dispatch(clearEditorMenu());
        }
      }}
      onUnlink={(): void => {
        unlinkLinkElement(editor, path);
        ReactEditor.focus(editor);
        dispatch(clearEditorMenu());
      }}
    />
  );
};
